(function () {
  'use strict';
  if (window.modifiedProductGallery) { window.modifiedProductGallery.init(document); return; }
  var initialized = new WeakSet();
  function initGallery(gallery) {
    if (initialized.has(gallery)) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    if (!track || !slides.length) return;
    initialized.add(gallery);
    var thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    var arrows = gallery.querySelector('[data-gallery-arrows]');
    var count = gallery.querySelector('[data-gallery-count]');
    var strip = gallery.querySelector('[data-gallery-thumbnails]');
    var product = gallery.closest('[data-product-root]');
    var filtered = gallery.dataset.filterColors === 'true';
    var colorIndex = Number(gallery.dataset.colorIndex);
    var color = gallery.dataset.selectedColor || '';
    var visible = [], active = 0, scrollFrame = 0;
    function pauseMedia(slide) {
      slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      slide.querySelectorAll('iframe').forEach(function (frame) {
        if (!frame.contentWindow) return;
        try {
          var origin = new URL(frame.src).origin;
          if (/youtube(?:-nocookie)?\.com$/.test(new URL(frame.src).hostname)) frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), origin);
          if (new URL(frame.src).hostname === 'player.vimeo.com') frame.contentWindow.postMessage(JSON.stringify({method:'pause'}), origin);
        } catch (error) {}
      });
    }
    function updateState(index) {
      active = Math.max(0, Math.min(index, visible.length - 1));
      var selected = visible[active];
      previous.disabled = active <= 0;
      next.disabled = active >= visible.length - 1;
      arrows.hidden = visible.length < 2;
      count.textContent = visible.length ? (active + 1) + ' / ' + visible.length : '';
      slides.forEach(function (slide) {
        var current = slide === selected;
        slide.setAttribute('aria-hidden', current ? 'false' : 'true');
        slide.inert = !current;
        if (!current) pauseMedia(slide);
      });
      thumbnails.forEach(function (thumbnail) {
        var current = selected && thumbnail.dataset.galleryThumbnail === selected.dataset.mediaId;
        if (current) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
        if (current && strip) {
          var left = thumbnail.offsetLeft - strip.offsetLeft;
          if (left < strip.scrollLeft) strip.scrollLeft = left;
          else if (left + thumbnail.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + thumbnail.offsetWidth - strip.clientWidth;
        }
      });
    }
    function goTo(index, smooth) {
      if (!visible.length) return;
      index = Math.max(0, Math.min(index, visible.length - 1));
      var motion = smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      updateState(index);
      track.scrollTo({left:index * track.clientWidth,behavior:motion ? 'smooth' : 'instant'});
    }
    function filter(nextColor, featuredId) {
      color = String(nextColor || '').toLowerCase();
      slides.forEach(function (slide) { slide.hidden = filtered && slide.dataset.mediaColor !== color; });
      thumbnails.forEach(function (thumbnail) { thumbnail.hidden = filtered && thumbnail.dataset.mediaColor !== color; });
      visible = slides.filter(function (slide) { return !slide.hidden; });
      var initial = featuredId ? visible.findIndex(function (slide) { return slide.dataset.mediaId === String(featuredId); }) : 0;
      goTo(Math.max(0, initial), false);
    }
    previous.addEventListener('click', function () { goTo(active - 1, true); });
    next.addEventListener('click', function () { goTo(active + 1, true); });
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () { goTo(visible.findIndex(function (slide) { return slide.dataset.mediaId === thumbnail.dataset.galleryThumbnail; }), true); });
    });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      var target;
      if (event.key === 'ArrowLeft') target = active - 1;
      else if (event.key === 'ArrowRight') target = active + 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = visible.length - 1;
      else return;
      event.preventDefault(); goTo(target, true);
    });
    track.addEventListener('scroll', function () {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(function () {
        scrollFrame = 0;
        var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (index !== active) updateState(index);
      });
    }, {passive:true});
    if (product) product.addEventListener('product:variant-change', function (event) {
      var variant = event.detail.variant;
      if (!variant) return;
      var nextColor = colorIndex >= 0 ? String(variant.options[colorIndex]).toLowerCase() : '';
      if (filtered) { if (nextColor !== color) filter(nextColor); }
      else if (variant.featured_media) goTo(slides.findIndex(function (slide) { return slide.dataset.mediaId === String(variant.featured_media.id); }), false);
    });
    var initialMedia;
    if (!filtered && product) {
      try {
        var variants = JSON.parse(product.querySelector('[data-variants]').textContent);
        var id = product.querySelector('[data-variant-id]').value;
        var variant = variants.find(function (item) { return String(item.id) === String(id); });
        initialMedia = variant && variant.featured_media && variant.featured_media.id;
      } catch (error) {}
    }
    filter(color, initialMedia);
    if ('ResizeObserver' in window) {
      var lastWidth = track.clientWidth;
      var observer = new ResizeObserver(function () { if (track.clientWidth !== lastWidth) { lastWidth = track.clientWidth; goTo(active, false); } });
      observer.observe(track);
      document.addEventListener('shopify:section:unload', function unload(event) {
        if (event.target.contains(gallery)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', unload); }
      });
    }
  }
  function init(scope) { scope.querySelectorAll('[data-product-gallery]').forEach(initGallery); }
  window.modifiedProductGallery = {init:init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
